@if (isHeaderPlacement()) {
  @if (!state.isOpen()) {
    <div class="ai-help-fab-shell ai-help-fab-shell--header">
      <button
        type="button"
        class="ai-help-fab ai-help-fab--header"
        aria-label="Open WorkLuge Assistant"
        (click)="onHeaderFabClick($event)"
      >
        <span
          class="ai-help-fab__tooltip-anchor"
        >
          <span class="ai-help-fab__header-content">
            <span class="ai-help-fab__avatar" aria-hidden="true">
              <span
                class="tim-name-tip tim-name-tip--below"
                [attr.aria-label]="timHoverLabel"
              >
                <img
                  class="ai-help-fab__hello"
                  src="assets/images/timh1.png"
                  alt=""
                  draggable="false"
                />
                <span class="tim-name-tip__bubble" aria-hidden="true">
                  <strong>TIM</strong> (TechWyse Intelligent Manager)
                </span>
              </span>
            </span>
            <span class="ai-help-fab__header-label"><span class="ai-help-fab__header-brand">WorkLuge</span> Assistant</span>
            <img
              class="ai-help-fab__header-gif"
              src="assets/images/ai-gm.gif"
              alt=""
              draggable="false"
              aria-hidden="true"
            />
          </span>
        </span>
      </button>
    </div>
  }
} @else if (isShellVisible()) {
<div
  class="ai-help-fab-shell"
  [class.ai-help-fab-shell--hidden]="state.isOpen()"
  [class.ai-help-fab-shell--dragging]="isDragging"
  [class.ai-help-fab-shell--custom]="hasCustomPosition"
  (pointerdown)="onDragStart($event)"
>
  <button
    type="button"
    class="ai-help-fab"
    aria-label="Open WorkLuge Assistant. Drag to move."
  >
    <span class="ai-help-fab__tooltip-anchor">
      <span class="ai-help-fab__avatar" aria-hidden="true">
        <span class="ai-help-fab__ripple ai-help-fab__ripple--1"></span>
        <span class="ai-help-fab__ripple ai-help-fab__ripple--2"></span>
        <span class="ai-help-fab__ripple ai-help-fab__ripple--3"></span>
        <span
          class="tim-name-tip tim-name-tip--left"
          [attr.aria-label]="timHoverLabel"
          [class.tim-name-tip--disabled]="isDragging"
        >
          <img
            class="ai-help-fab__hello"
            src="assets/images/timh2.png"
            alt=""
            draggable="false"
          />
          <span class="tim-name-tip__bubble" aria-hidden="true">
            <strong>TIM</strong> (TechWyse Intelligent Manager)
          </span>
        </span>
      </span>
    </span>
  </button>
</div>
} @else if (!state.isOpen()) {
<button
  type="button"
  class="ai-help-fab-shell__minimized"
  aria-label="Restore WorkLuge Assistant"
  matTooltip="Restore assistant"
  matTooltipPosition="left"
  matTooltipClass="ai-help-fab-drag-tooltip"
  matTooltipShowDelay="200"
  (click)="restoreShell($event)"
>
  <span class="ai-help-fab-shell__minimized-peek" aria-hidden="true">
    <img
      class="ai-help-fab-shell__minimized-img"
      src="assets/images/timv1.png"
      alt=""
      draggable="false"
    />
  </span>
</button>
}
